import { render, staticRenderFns } from "./KidsSearchExtendDialog.vue?vue&type=template&id=7d47c51e&scoped=true"
import script from "./KidsSearchExtendDialog.vue?vue&type=script&lang=js"
export * from "./KidsSearchExtendDialog.vue?vue&type=script&lang=js"
import style0 from "./KidsSearchExtendDialog.vue?vue&type=style&index=0&id=7d47c51e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d47c51e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d47c51e')) {
      api.createRecord('7d47c51e', component.options)
    } else {
      api.reload('7d47c51e', component.options)
    }
    module.hot.accept("./KidsSearchExtendDialog.vue?vue&type=template&id=7d47c51e&scoped=true", function () {
      api.rerender('7d47c51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/KidsSearchExtendDialog.vue"
export default component.exports